'use client';

import React, { useCallback } from 'react';

import { RedisTreatment } from '../../../../../../lib/redis/types/RedisTreatment';
import { bloomreachPixelSendCategoryView } from '../../../../../../modules/analytics/bloomreach/BloomreachPixel/sendBloomreachPageViewTrackingEvent';

import TreatmentSortAndFilter from '../../../../../../components/Treatment/TreatmentSortAndFilter/TreatmentSortAndFilter';
import TreatmentCard from '../../../../../../components/Treatment/TreatmentCard/TreatmentCard';
import SortAndFilterResults from '../../../../../../components/Treatment/TreatmentSortAndFilter/SortAndFilterResults/SortAndFilterResults';
import FilterTagCloud from '../../../../../../components/Treatment/TreatmentSortAndFilter/FilterTagCloud/FilterTagCloud';
import SortAndFilterActions from '../../../../../../components/Treatment/TreatmentSortAndFilter/SortAndFilterActions/SortAndFilterActions';
import SortAndFilterNoResults from '../../../../../../components/Treatment/TreatmentSortAndFilter/SortAndFilterNoResults/SortAndFilterNoResults';

import styles from './ConditionPageTreatments.module.css';

type TreatmentSortAndFilterProps = Pick<React.ComponentProps<typeof TreatmentSortAndFilter>, 'pageConfig' | 'globalConfig' | 'treatments'>;

interface Props extends TreatmentSortAndFilterProps {
    conditionId: number;
    disableBoxShadow?: boolean
}

const ConditionPageTreatments = ({ treatments, pageConfig, globalConfig, conditionId, disableBoxShadow }: Props) => {
    const sortFilterChange = useCallback(() => {
        bloomreachPixelSendCategoryView({
            cat: `home|${window.location.pathname.replace('/', '')}`,
            cat_id: conditionId!.toString(),
        });
    }, [conditionId]);

    return (
        <TreatmentSortAndFilter
            treatments={treatments as unknown as RedisTreatment[]}
            pageConfig={pageConfig}
            globalConfig={globalConfig}
            urlKey="condition"
            onFilterChange={sortFilterChange}
            onSortChange={sortFilterChange}
        >
            <SortAndFilterActions />
            <FilterTagCloud />
            <SortAndFilterResults>
                {({ filteredTreatments, numberOfFiltersApplied }) => {
                    if (numberOfFiltersApplied && !filteredTreatments.length) {
                        return <SortAndFilterNoResults />;
                    }

                    return (
                        <ul className={styles.treatments}>
                            {filteredTreatments.map(
                                (treatment) => (
                                    <li key={treatment._id}>
                                        <TreatmentCard
                                            disableBoxShadow
                                            treatment={treatment}
                                            link={treatment.relativeUrl}
                                            className="h-full"
                                        />
                                    </li>
                                )
                            )}
                        </ul>
                    );
                }}
            </SortAndFilterResults>
        </TreatmentSortAndFilter>
    );
};

export default ConditionPageTreatments;
